<template>
  <div>
    <h3>Password Reset Requested</h3>
    <p>
      If an account matching the email provided exists in our system, we will send a password reset link shortly.<br/><br />
      Please allow a few minutes for the email to arrive and check your spam or junk folder.<br /><br />
      If you do not receive an email, please verify that you are using the correct email address or contact support for assistance.
    </p>
    <div class="ly-row center-button">
      <router-link to="/login"> <lp-button type="button" id="fgt-back-to-login">Return to Sign In</lp-button></router-link>
    </div>
  </div>
</template>

<style>
.reset-password-form {
  margin: 0px 0px;
  padding: 0px 0px;
}
.center-button {
  display: flex;
  justify-content: center;
}
#fgt-back-to-login {
  min-width: 200px;
}
</style>
